import {
  Address, PriceGroup, Sort, Price,
} from '@printdeal/product-selector';
import { configurationProvider } from '@printdeal/configuration';
import Api from '../Api';
import { ISelection } from '../../types/selector/Selector';
import { McpProduct } from '../../types/product/product';

export interface GetProductPricesParams {
  productKey: string,
  selection: ISelection,
  address: Address,
  quantity: number[],
  mcpSku: string,
  customerGroupId?: string,
  sort: Sort[],
  group?: PriceGroup[],
  customHeaders?: Record<string, string>,
  productVersion?: number,
}

class ProductService extends Api {
  /**
   * This can be used as a fetcher
   */
  get = async <T>(url: string) => {
    const { data } = await this.httpClient.get<T>(url);
    return Promise.resolve(data);
  };

  validateSelection = async ({
    selection,
    comboSelection,
    productDetailPageId,
    customerGroupId,
  }: {
    selection: string,
    comboSelection: string,
    productDetailPageId: string,
    customerGroupId?: string
  }): Promise<{ valid: boolean, price: Price, originalPrice: Price }> => {
    const params = new URLSearchParams();
    params.append('storeKey', configurationProvider.getValue('STORE_KEY'));
    params.append('selection', selection);

    if (comboSelection) {
      params.append('comboSelection', comboSelection);
    }

    if (customerGroupId) {
      params.append('customerGroupId', customerGroupId);
    }

    const { data } = await this.httpClient.get(`/product/validate/${productDetailPageId}`, {
      params,
    });
    return Promise.resolve(data);
  };

  getProductDiscount = async ({
    productKey,
    quantity,
    centAmount,
    customerGroupId,
  }: {
    productKey: string,
    quantity?: number,
    centAmount?: number,
    customerGroupId?: string,
  }) => {
    const params = new URLSearchParams();
    params.append('storeKey', process.env.GATSBY_STORE || '');

    if (quantity) {
      params.append('quantity', String(quantity));
    }

    if (centAmount) {
      params.append('centAmount', String(centAmount));
    }

    if (customerGroupId) {
      params.append('customerGroupId', customerGroupId);
    }

    const { data } = await this.httpClient.get(`/product/${productKey}/discounts`, {
      params,
    });
    return Promise.resolve(data);
  };

  convertProduct = async (
    variableAttributes: ISelection, productKey?: string, customHeaders?: Record<string, string>,
  ): Promise<McpProduct | undefined> => {
    if (!productKey) {
      return undefined;
    }

    const params = new URLSearchParams();
    params.append('variableAttributes', JSON.stringify(variableAttributes));
    const { data: mcpProduct } = await this.httpClient.get<McpProduct>(`/product/convert/${productKey}`, {
      params,
      headers: customHeaders || {},
    });
    return Promise.resolve(mcpProduct);
  };
}

export default ProductService;
